export default "__VITE_ASSET__4TR8hQKA__"